var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecordHeader = function SvgRecordHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.824,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E03"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.824 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.824 19.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0-3a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z",
    fill: "#fff"
  })));
};
export default SvgRecordHeader;